import * as actions from "./home.actions";
import * as mutations from "./home.mutations";
import * as getters from "./home.getters";
import state from "./home.state";
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const home = {
  namespaced,
  getters,
  mutations,
  actions,
  state
};

export default home;
